module.exports = __webpack_public_path__ + "static/img/task4.ab48dc0f.png";